module.exports = __webpack_public_path__ + "img/pic_zht@2x.81dce278.png";